import salientFixture from '../../fixtures/proof/salient-provisional.json' with { type: 'json' };
import repetitionFixture from '../../fixtures/proof/repetition-trap.json' with { type: 'json' };
import recallFixture from '../../fixtures/proof/recall-self-promotion.json' with { type: 'json' };
import instabilityFixture from '../../fixtures/proof/instability-freeze.json' with { type: 'json' };
import governedFixture from '../../fixtures/proof/governed-promotion.json' with { type: 'json' };
import quarantineFixture from '../../fixtures/break/quarantined-evidence.json' with { type: 'json' };
import { createExperienceEvent } from '../models/event.js';
import { createEvidenceItem } from '../models/evidence.js';

const fixtureEntries = [
  [salientFixture, 'fixtures/proof/salient-provisional.json'],
  [repetitionFixture, 'fixtures/proof/repetition-trap.json'],
  [recallFixture, 'fixtures/proof/recall-self-promotion.json'],
  [instabilityFixture, 'fixtures/proof/instability-freeze.json'],
  [governedFixture, 'fixtures/proof/governed-promotion.json'],
  [quarantineFixture, 'fixtures/break/quarantined-evidence.json']
];

function deepFreeze(value) {
  if (value && typeof value === 'object' && !Object.isFrozen(value)) {
    Object.values(value).forEach(deepFreeze);
    Object.freeze(value);
  }
  return value;
}

function hydrateFixture(fixture, fixturePath) {
  const fixtureContent = structuredClone(fixture);
  return deepFreeze({
    ...fixture,
    fixturePath,
    fixtureContent,
    orderedEvents: fixture.orderedEvents.map(createExperienceEvent),
    evidence: fixture.evidence.map(createEvidenceItem)
  });
}

export const scenarios = Object.freeze(fixtureEntries.map(([fixture, path]) => hydrateFixture(fixture, path)));
export const getScenario = (scenarioId) => scenarios.find((item) => item.scenarioId === scenarioId);
